/* Bladronix: kalinti gorunumu, galeri, paket secimi, scroll reveal */
(function () {
  var d = document;
  // dil (2026-10-18): Shopify dil yolu (/ ya da /de/) ve JS metinleri (layout'taki window.BX_T)
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = function (s) { return (window.BX_T && window.BX_T[s]) || s; };

  // hero: kalinti gorunumu (illustrasyon). Sayfa acilinca bir kez kendiliginden gosterir.
  var hero = d.querySelector('.hero'), tg = d.querySelector('[data-residue]');
  if (hero && tg) {
    var set = function (on) { hero.classList.toggle('is-residue', on); tg.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    tg.addEventListener('click', function () { set(!hero.classList.contains('is-residue')); });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) setTimeout(function () { set(true); }, 1400);
  }

  // galeri: slaytlar ust uste hazir, gecis aninda. Ana gorsel tiklaninca lightbox.
  var gal = d.querySelector('[data-gal]'), main = gal && gal.querySelector('.gal__main');
  var slides = gal ? [].slice.call(gal.querySelectorAll('.gal__slide')) : [];
  var thumbs = gal ? [].slice.call(gal.querySelectorAll('.gal__thumbs button')) : [];
  var cur = Math.max(0, slides.findIndex(function (x) { return x.classList.contains('is-on'); }));
  var show = function (i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (x, j) { x.classList.toggle('is-on', j === cur); });
    thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
    var tb = thumbs[cur], wrap = tb && tb.parentNode;   // tek satir serit: aktif kucuk resmi gorunur tut (2026-09-25)
    if (tb && wrap) { var l = tb.offsetLeft - (wrap.clientWidth - tb.offsetWidth) / 2; wrap.scrollTo({ left: Math.max(0, l), behavior: 'smooth' }); }
  };
  thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
  show(cur);

  // lightbox: kaydirarak (swipe / scroll-snap), oklar, klavye
  // 2026-10-25 (Cheriemood'daki duzeltme, patron: "bladronix içinde aynı düzeltmeyi yap"): kare sayfadaki hazir halle aninda acilir
  // (eskiden buyuk kareler bastan ve tembel iniyordu, telefonda 1,3 ile 1,7 sn bekletiyordu); ekran daha keskin isterse yalniz bakilan
  // kare ve iki komsusu arkadan iner, inince yer degistirir. Buyuk kare gelmezse kucugu kalir. Oklar ve klavye 0,2 sn'de gecer.
  var lb, track, count, cap, lbImgs = [], pos = 0, moving = false, anim = 0;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var icon = function (dp) { return '<svg viewBox="0 0 20 20" fill="none"><path d="' + dp + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
  var sharp = function (i) {
    var need = Math.min(track.clientWidth, track.clientHeight) * (window.devicePixelRatio || 1);
    [i, i + 1, i - 1].forEach(function (j) {
      var im = lbImgs[j], full = slides[j] && slides[j].dataset.full;
      if (!im || im._hd || !full || im.src === full) return;
      var have = im.naturalWidth || +((im.src.match(/[?&]width=(\d+)/) || [])[1] || 0);
      if (have >= need) return;
      im._hd = true;
      var hd = new Image(); hd._hd = true; hd.alt = im.alt; hd.src = full;
      (hd.decode ? hd.decode() : new Promise(function (ok, no) { hd.onload = ok; hd.onerror = no; }))
        .then(function () { if (im.parentNode) { im.parentNode.replaceChild(hd, im); lbImgs[j] = hd; } })
        .catch(function () {});
    });
  };
  var buildLb = function () {
    lb = d.createElement('div'); lb.className = 'lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', T('Image viewer'));
    lb.innerHTML = '<div class="lb__track"></div><div class="lb__bar"><span class="lb__count"></span><button class="lb__btn lb__close" type="button" aria-label="' + T('Close') + '">' + icon('M5 5l10 10M15 5L5 15') + '</button></div>' +
      '<button class="lb__btn lb__nav lb__prev" type="button" aria-label="' + T('Previous image') + '">' + icon('M12 4l-6 6 6 6') + '</button>' +
      '<button class="lb__btn lb__nav lb__next" type="button" aria-label="' + T('Next image') + '">' + icon('M8 4l6 6-6 6') + '</button><p class="lb__cap"></p>';
    track = lb.querySelector('.lb__track'); count = lb.querySelector('.lb__count'); cap = lb.querySelector('.lb__cap');
    slides.forEach(function (x) {
      var s = d.createElement('div'); s.className = 'lb__slide';
      var im = d.createElement('img'); im.src = x.currentSrc || x.src; im.alt = x.alt; im.decoding = 'async';
      im.onerror = function () { im.onerror = null; if (x.dataset.full && im.src !== x.dataset.full) im.src = x.dataset.full; };
      s.appendChild(im); track.appendChild(s); lbImgs.push(im);
    });
    var at = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var label = function () {
      if (!moving) { pos = at(); sharp(pos); }
      count.textContent = (pos + 1) + ' / ' + slides.length; cap.textContent = slides[pos] ? slides[pos].alt : '';
    };
    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i)); pos = i; sharp(i);
      var from = track.scrollLeft, to = i * track.clientWidth, id = ++anim, t0 = 0;
      if (RM || Math.abs(to - from) < 2) { track.scrollLeft = to; label(); return; }
      moving = true; track.style.scrollSnapType = 'none';
      // once kareye oturtmayi ac, sonra hedefe koy: tersi olunca tarayici eski kareye geri oturtuyordu (yeniden oturtma kurali)
      var end = function () { if (id !== anim) return; anim++; moving = false; track.style.scrollSnapType = ''; track.scrollLeft = to; label(); };
      var step = function (ts) {
        if (id !== anim) return;
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 200);
        track.scrollLeft = from + (to - from) * (1 - Math.pow(1 - p, 3));
        if (p < 1) window.requestAnimationFrame(step); else end();
      };
      window.requestAnimationFrame(step);
      setTimeout(end, 260);   // kare cizimi durursa (arka plandaki pencere) yine yerine otursun
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(label); }, { passive: true });
    lb.querySelector('.lb__prev').addEventListener('click', function () { go(pos - 1); });
    lb.querySelector('.lb__next').addEventListener('click', function () { go(pos + 1); });
    lb.querySelector('.lb__close').addEventListener('click', closeLb);
    track.addEventListener('click', function (ev) { if (ev.target === track || ev.target.classList.contains('lb__slide')) closeLb(); });
    d.addEventListener('keydown', function (ev) {
      if (!lb.classList.contains('is-open')) return;
      if (ev.key === 'Escape') closeLb();
      if (ev.key === 'ArrowRight') go(pos + 1);
      if (ev.key === 'ArrowLeft') go(pos - 1);
    });
    lb._label = label;
    d.body.appendChild(lb);
  };
  var closeLb = function () {
    anim++; moving = false; track.style.scrollSnapType = '';
    lb.classList.remove('is-open'); d.body.classList.remove('lb-lock');
    show(pos); if (main) main.focus();
  };
  var openLb = function () {
    if (!slides.length) return;
    if (!lb) buildLb();
    lb.classList.add('is-open'); d.body.classList.add('lb-lock');
    track.scrollTo({ left: cur * track.clientWidth, behavior: 'auto' }); pos = cur; lb._label();
    lb.querySelector('.lb__close').focus();
  };
  // ana gorsel: oklar ve parmakla kaydirma, buyutmeden gecis (2026-09-25)
  var swiped = false;
  if (main) {
    main.querySelectorAll('[data-gnav]').forEach(function (b) { b.addEventListener('click', function (ev) { ev.stopPropagation(); show(cur + (+b.dataset.gnav)); }); });
    var tx = null, ty = null;
    main.addEventListener('touchstart', function (ev) { tx = ev.touches[0].clientX; ty = ev.touches[0].clientY; swiped = false; }, { passive: true });
    main.addEventListener('touchend', function (ev) {
      if (tx === null) return; var dx = ev.changedTouches[0].clientX - tx, dy = ev.changedTouches[0].clientY - ty; tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(cur + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    main.addEventListener('click', function (ev) { if (swiped) { swiped = false; return; } openLb(); });
    main.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); openLb(); } });
  }

  // para birimi (2026-10-09): ziyaretcinin para birimi <body data-cur data-sym>'den, Liquid money_with_currency gibi "$115.00 AUD"
  // ccy (2026-10-16): once adi "cur" idi, galerinin kare sirasi da "cur" (ayni fonksiyon): acilista ok/kaydirma galeriyi bosaltiyor, fiyat "$19.99 8" oluyordu
  var ccy = d.body.getAttribute('data-cur') || 'USD', sym = d.body.getAttribute('data-sym') || '$';
  // 2026-10-19: JS'in hesapladigi fiyat Shopify'in para bicimiyle (data-mf = 1234,56'nin bicimi): EUR'da "€18,95 EUR", Liquid'deki gibi
  var mf = d.body.getAttribute('data-mf') || '', mfm = mf.match(/1(\D?)234(\D)56/);
  var fmt = function (c) {
    if (!mfm) return sym + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + ccy;
    var n = (Math.round(c) / 100).toFixed(2).split('.');
    return mf.replace(/1\D?234\D56/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, mfm[1]) + mfm[2] + n[1]);
  };

  // bone paketleri (2026-10-18, patron: "varyasyon farketmeksizin 3lu 4lu fiyat uygulansin"): sepetteki butun Triple boneler renkten
  // bagimsiz en ucuz pakete bolunur (5 = 4'lu + tekli); renkleri karisan paket Mixed Pack urununden gider ("3 Black + 1 Navy Floral").
  // Veri #bx-caps (build_site.py caps_json). Kullananlar: bone sayfasi formu ve fiyati, "Just want the cap?", sepet sayfasi.
  var capPack = (function () {
    var el = d.getElementById('bx-caps'), j = null;
    try { j = el && JSON.parse(el.textContent); } catch (x) {}
    if (!j || !j.t || !j.t.length) return null;
    var info = {}, cols = [], ids = {}, pr = {}, mix = {};
    j.t.forEach(function (v) {            // [id, renk, "2 Caps", fiyat]
      var n = parseInt(v[2], 10) || 1, c = {}; c[v[1]] = n; info[v[0]] = c;
      if (cols.indexOf(v[1]) < 0) cols.push(v[1]);
      ids[v[1] + '|' + n] = v[0]; if (pr[n] === undefined) pr[n] = v[3];
    });
    var key = function (c) { return cols.map(function (k) { return c[k] || 0; }).join(','); };
    (j.m || []).forEach(function (v) {    // [id, "3 Black + 1 Navy Floral"]
      var c = {}; String(v[1]).split(' + ').forEach(function (x) { var m = x.match(/^(\d+) (.+)$/); if (m) c[m[2]] = +m[1]; });
      info[v[0]] = c; mix[key(c)] = v[0];
    });
    var sizes = Object.keys(pr).map(Number);
    var dp = function (N) {               // N bone -> en ucuz paket boyutlari, buyukten kucuge
      var best = [0], pick = [0], out = [];
      for (var q = 1; q <= N; q++) { best[q] = Infinity; sizes.forEach(function (k) { if (k <= q && best[q - k] + pr[k] < best[q]) { best[q] = best[q - k] + pr[k]; pick[q] = k; } }); }
      for (var r = N; r > 0; r -= pick[r]) out.push(pick[r]);
      return { parts: out.sort(function (a, b) { return b - a; }), sum: best[N] };
    };
    var plan = function (cnt) {           // {renk: adet} -> sepet satirlari, toplam, tek tek toplam
      var seq = [], out = {}, ok = true, at = 0;
      cols.forEach(function (k) { for (var i = 0; i < (cnt[k] || 0); i++) seq.push(k); });
      var r = dp(seq.length), sum = r.sum;
      r.parts.forEach(function (k) {     // renkler sirali, her paket ardisik bonelerden: en fazla bir karisik paket
        var c = {}; seq.slice(at, at + k).forEach(function (x) { c[x] = (c[x] || 0) + 1; }); at += k;
        var cs = Object.keys(c), id = cs.length === 1 ? ids[cs[0] + '|' + k] : mix[key(c)];
        if (id) out[id] = (out[id] || 0) + 1; else ok = false;
      });
      if (!ok) {                          // karisik paket urunu yoksa her renk kendi paketiyle
        out = {}; sum = 0;
        cols.forEach(function (k) { var rr = dp(cnt[k] || 0); sum += rr.sum; rr.parts.forEach(function (n) { var id = ids[k + '|' + n]; out[id] = (out[id] || 0) + 1; }); });
      }
      return { items: Object.keys(out).map(function (id) { return { id: +id, quantity: out[id] }; }), sum: sum, full: seq.length * (pr[1] || 0) };
    };
    var add = function (cnt, id, q) { var c = info[id]; if (c) Object.keys(c).forEach(function (k) { cnt[k] = (cnt[k] || 0) + c[k] * q; }); return cnt; };
    var post = function (u, b) {
      return fetch(R + u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
        .then(function (r) { if (!r.ok) throw new Error(u); return r; });
    };
    // sepetteki boneleri (ve extra: {renk: adet} eklenecekleri) en ucuz paketlere cevirir; once yeniler eklenir, sonra eskiler
    // duzeltilir (ekleme olmazsa sepetten bir sey dusmez). Sepet degistiyse true.
    var apply = function (extra) {
      return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var have = {}, cnt = {}, want = {}, neu = [], upd = {}, ch = false;
        (cart.items || []).forEach(function (l) { if (info[l.variant_id]) { have[l.variant_id] = (have[l.variant_id] || 0) + l.quantity; add(cnt, l.variant_id, l.quantity); } });
        Object.keys(extra || {}).forEach(function (k) { cnt[k] = (cnt[k] || 0) + extra[k]; });
        plan(cnt).items.forEach(function (x) { want[x.id] = x.quantity; });
        Object.keys(want).forEach(function (id) { if (!have[id]) neu.push({ id: +id, quantity: want[id] }); });
        Object.keys(have).forEach(function (id) { if (have[id] !== (want[id] || 0)) { upd[id] = want[id] || 0; ch = true; } });
        if (!neu.length && !ch) return false;
        return (neu.length ? post('cart/add.js', { items: neu }) : Promise.resolve())
          .then(function () { return ch ? post('cart/update.js', { updates: upd }) : null; }).then(function () { return true; });
      });
    };
    return { plan: plan, apply: apply, add: add, info: function (id) { return info[id]; } };
  })();

  // varyant secimi: secenek gruplari -> varyant JSON'undan eslesen varyant (id, fiyat, gorsel)
  var vid = d.getElementById('bx-variant'), cp = d.getElementById('bx-cta-price'), vj = d.getElementById('bx-variants');
  var variants = []; try { variants = JSON.parse(vj ? vj.textContent : '[]'); } catch (x) {}
  var groups = d.querySelectorAll('.bx-form fieldset[data-opt]'), qtyIn = d.getElementById('bx-qty'), curV = null;
  var qty = function () { return Math.min(20, Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1)); };
  var showPrice = function () {
    if (!curV) return;
    var t = fmt(capPack && capPack.info(curV.id) ? capPack.plan(capPack.add({}, curV.id, qty())).sum : curV.price * qty());
    if (cp) cp.textContent = t;
    d.querySelectorAll('[data-live-price]').forEach(function (x) { x.textContent = t; });
  };
  var pick = function (ev) {
    var sel = []; groups.forEach(function (g) { var c = g.querySelector('input:checked'); sel[+g.dataset.opt] = c ? c.value : null; });
    var v = variants.filter(function (x) { return sel.every(function (s, i) { return x.options[i] === s; }); })[0];
    if (!v) return;
    curV = v;
    if (vid) vid.value = v.id;
    showPrice();
    if (ev && v.featured_image) { var k = slides.findIndex(function (x) { return +x.dataset.id === v.featured_image.id; }); if (k > -1) show(k); }
  };
  groups.forEach(function (g) { g.addEventListener('change', pick); });
  if (variants.length) { if (groups.length) pick(); else { curV = variants[0]; showPrice(); } }
  // kit sayfasi (2026-09-25, revize): acilir menu ile bone secimi (gorsel + galeri karesi), ek boneler 15 USD, toplam, add.js ile coklu ekleme
  var kitForm = d.querySelector('[data-kit-form]'), capSelEl = d.querySelector('[data-capsel]'), capSelImg = d.querySelector('[data-capsel-img]');
  var syncCapSel = function (jump) {
    if (!capSelEl) return;
    var o = capSelEl.options[capSelEl.selectedIndex];
    if (capSelImg && o.dataset.img) capSelImg.src = o.dataset.img;
    if (jump && o.dataset.name) { var k = slides.findIndex(function (x) { return (x.dataset.name || '').indexOf(o.dataset.name) === 0; }); if (k > -1) show(k); }
  };
  if (capSelEl) {
    // varyant eslesmesi: select degeri = option1
    var selPick = function (ev) {
      var v = variants.filter(function (x) { return x.options[0] === capSelEl.value; })[0];
      if (v) { curV = v; if (vid) vid.value = v.id; }
      syncCapSel(!!ev); kitTotal();
    };
    capSelEl.addEventListener('change', selPick);
  }
  var xq = kitForm ? [].slice.call(kitForm.querySelectorAll('[data-xcap-qty] input')) : [], xsum = d.querySelector('[data-xcap-sum]');
  var addonVars = []; try { var aj = d.getElementById('bx-addon-variants'); addonVars = JSON.parse(aj ? aj.textContent : '[]') || []; } catch (x) {}
  var xcount = function () { return xq.reduce(function (a, i) { return a + (parseInt(i.value, 10) || 0); }, 0); };
  var capCount = function () {                          // {renk: adet}: bone menusundeki secili renk, adet satirindaki sayi
    var o = capSelEl && capSelEl.options[capSelEl.selectedIndex], c = {};
    if (o && o.dataset.color) c[o.dataset.color] = qty();
    return c;
  };
  var kitTotal = function () {
    if (!kitForm) return;
    if (bnd && bundleOf() === 'cap') {                   // yalniz bone (2026-10-19): menudeki renkten adet kadar, en ucuz paketlerle
      var r = capCount(), pl = capPack ? capPack.plan(r) : { sum: 0, full: 0 }, tc = fmt(pl.sum), sv = d.querySelector('[data-cap-save]');
      if (cp) cp.textContent = tc; d.querySelectorAll('[data-live-price]').forEach(function (x) { x.textContent = tc; });
      if (sv) { sv.hidden = pl.full - pl.sum < 1; sv.textContent = T('Save {0}').replace('{0}', fmt(pl.full - pl.sum)); }
      return;
    }
    if (!curV) return;
    var kits = qty(), xn = xcount(), xunit = addonVars.length ? addonVars[0].price : 1500;
    var t = fmt(curV.price * kits + xunit * xn);
    if (cp) cp.textContent = t; d.querySelectorAll('[data-live-price]').forEach(function (x) { x.textContent = t; });
    if (xsum) { xsum.hidden = xn === 0; xsum.textContent = T(xn === 1 ? '{0} extra cap, {1} added to your kit.' : '{0} extra caps, {1} added to your kit.').replace('{0}', xn).replace('{1}', fmt(xunit * xn)); }
  };
  if (kitForm) {
    kitForm.querySelectorAll('[data-xcap-qty] [data-q]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); var i = b.parentNode.querySelector('input'); i.value = Math.min(10, Math.max(0, (parseInt(i.value, 10) || 0) + (+b.dataset.q))); kitTotal(); });
    });
    xq.forEach(function (i) { i.addEventListener('change', kitTotal); });
    kitForm.addEventListener('submit', function (ev) {
      if (bnd && bundleOf() === 'cap') {                 // yalniz bone: secilen boneler en ucuz paketlere bolunup sepete (capPack)
        ev.preventDefault();
        var go = function () { window.location.href = ret ? ret.value : R + 'checkout'; };
        if (!capPack) return;
        capPack.apply(capCount()).then(go).catch(go);
        return;
      }
      var items = [];
      xq.forEach(function (i) {
        var n = parseInt(i.value, 10) || 0, v = addonVars.filter(function (x) { return x.options[0] === i.dataset.vopt; })[0];
        if (n > 0 && v) items.push({ id: v.id, quantity: n });
      });
      if (!items.length) return;                         // sadece kit: normal form gonderimi
      ev.preventDefault();
      if (curV) items.unshift({ id: curV.id, quantity: qty() });
      var to = ret ? ret.value : R + 'checkout';
      fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location.href = to; }).catch(function () { window.location.href = to; });
    });
  }
  // set secimi (2026-10-18, patron): The Night Kit ya da The Starter Set; ayni bone menusu, varyant listesi secilen setin urunu.
  // [data-bshow] ogeleri secime gore gorunur; ek boneler yalniz kitle (set secilince sifirlanir); secilince galeri setin karesine atlar.
  // 2026-10-19 (patron): ucuncu secim "cap", yalniz bone; bone menusu ve adet ayni, fiyat paket fiyatindan (kitTotal)
  var bnd = kitForm ? kitForm.querySelector('[data-bundle]') : null, bvars = { kit: variants };
  try { var bsj = d.getElementById('bx-variants-starter'); if (bsj) bvars.starter = JSON.parse(bsj.textContent) || []; } catch (x) {}
  var bundleOf = function () { var c = bnd && bnd.querySelector('input:checked'); return c ? c.value : 'kit'; };
  var bundleSet = function (jump) {
    var b = bundleOf(), c = bnd.querySelector('input:checked');
    variants = (bvars[b] && bvars[b].length) ? bvars[b] : bvars.kit;
    d.querySelectorAll('[data-bshow]').forEach(function (x) { x.hidden = x.dataset.bshow.split(' ').indexOf(b) < 0; });
    if (b !== 'kit') xq.forEach(function (i) { i.value = 0; });
    if (capSelEl) { var v = variants.filter(function (x) { return x.options[0] === capSelEl.value; })[0]; if (v) { curV = v; if (vid) vid.value = v.id; } }
    kitTotal();
    if (jump && c && c.dataset.name) { var k = slides.findIndex(function (x) { return (x.dataset.name || '').indexOf(c.dataset.name) === 0; }); if (k > -1) show(k); }
  };
  if (bnd) { bnd.addEventListener('change', function () { bundleSet(true); }); if (bundleOf() !== 'kit') bundleSet(true); }
  if (capSelEl && variants.length) { var v0 = variants.filter(function (x) { return x.options[0] === capSelEl.value; })[0]; if (v0) { curV = v0; if (vid) vid.value = v0.id; } syncCapSel(false); }
  var showPriceBase = showPrice; showPrice = function () { if (kitForm) kitTotal(); else showPriceBase(); }; if (kitForm) kitTotal();

  // kit parcalari tek tek (2026-09-25): acilir satirdaki isaretli parcalar -> toplam, "Add to cart" add.js ile sepete, bone satiri ustteki secimi izler
  var parts = d.querySelector('[data-parts]');
  if (parts) {
    var pchk = [].slice.call(parts.querySelectorAll('input[data-part]')), psum = parts.querySelector('[data-parts-sum]'), pbtn = parts.querySelector('[data-parts-add]'), phint = parts.querySelector('[data-parts-hint]');
    var capRow = parts.querySelector('input[data-part-cap]'), capMap = {}; try { var cj = d.getElementById('bx-cap-variants'); capMap = JSON.parse(cj ? cj.textContent : '{}') || {}; } catch (x) {}
    var capNm = parts.querySelector('[data-parts-capname]'), capPr = parts.querySelector('[data-parts-capprice]'), capIm = parts.querySelector('[data-parts-capimg]');
    var syncCapRow = function () {
      if (!capRow || !capSelEl) return;
      var m = capMap[capSelEl.value]; if (!m) return;
      capRow.value = m.id; capRow.dataset.price = m.price;
      if (capNm) capNm.textContent = 'Night Cap, ' + capSelEl.value;
      if (capPr) capPr.textContent = fmt(m.price);
      if (capIm) { var o = capSelEl.options[capSelEl.selectedIndex]; if (o && o.dataset.img) capIm.src = o.dataset.img; }
    };
    var partsTotal = function () {
      syncCapRow();
      var s = 0, n = 0; pchk.forEach(function (c) { if (c.checked) { s += +c.dataset.price || 0; n++; } });
      psum.textContent = fmt(s); pbtn.disabled = n === 0;
      if (phint) phint.hidden = !(s >= (+parts.dataset.kitPrice || 0));
    };
    parts.addEventListener('change', partsTotal);
    if (capSelEl) capSelEl.addEventListener('change', partsTotal);
    partsTotal();
    pbtn.addEventListener('click', function () {
      var items = pchk.filter(function (c) { return c.checked && +c.value; }).map(function (c) { return { id: +c.value, quantity: 1 }; });
      if (!items.length) return;
      pbtn.disabled = true;
      fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location.href = R + 'cart'; }).catch(function () { window.location.href = R + 'cart'; });
    });
  }

  // adet (2026-09-25): eksi/arti ve elle giris, buton fiyati adetle carpilir
  var pq = d.querySelector('[data-pdp-qty]');
  if (pq && qtyIn) {
    pq.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { qtyIn.value = Math.min(20, Math.max(1, qty() + (+b.dataset.q))); showPrice(); }); });
    qtyIn.addEventListener('input', showPrice);
    qtyIn.addEventListener('change', function () { qtyIn.value = qty(); showPrice(); });
  }

  // kendin sec: isaretli parcalar -> toplam; checkout = /cart/ID:1,ID:1 (cart permalink)
  var byo = d.querySelector('.byo');
  if (byo) {
    var kit = +byo.dataset.kitPrice, tot = byo.querySelector('[data-byo-total]'), nudge = byo.querySelector('[data-byo-nudge]');
    var capChk = byo.querySelector('[data-byo-cap]'), capSel = byo.querySelector('[data-byo-capsel]');
    var qOf = function (el) { var i = el.closest('.byo__row').querySelector('[data-byo-qty] input'); return Math.min(20, Math.max(1, parseInt(i && i.value, 10) || 1)); };
    var items = function () {
      var out = [];
      if (capChk && capChk.checked && capSel) { var o = capSel.options[capSel.selectedIndex]; out.push([o.value, +o.dataset.price * qOf(capChk), qOf(capChk)]); }
      byo.querySelectorAll('input[data-byo]:checked').forEach(function (c) { out.push([c.value, +c.dataset.price * qOf(c), qOf(c)]); });
      return out;
    };
    byo.querySelectorAll('[data-byo-qty] [data-q]').forEach(function (b) {
      b.addEventListener('click', function () { var i = b.parentNode.querySelector('input'); i.value = Math.min(20, Math.max(1, (parseInt(i.value, 10) || 1) + (+b.dataset.q))); upd(); });
    });
    byo.querySelectorAll('[data-byo-qty] input').forEach(function (i) { i.addEventListener('input', function () { upd(); }); });
    var capImg = byo.querySelector('[data-byo-capimg]'), alt = byo.querySelector('[data-byo-alt]');
    var upd = function () {
      if (capImg && capSel) { var oi = capSel.options[capSel.selectedIndex]; if (oi && oi.dataset.img) capImg.src = oi.dataset.img; }
      var s = items().reduce(function (a, x) { return a + x[1]; }, 0);
      tot.textContent = fmt(s);
      if (nudge) nudge.hidden = !(s >= kit);
      if (alt) alt.hidden = !(s >= kit);
      if (capSel) capSel.disabled = !(capChk && capChk.checked);
    };
    byo.addEventListener('change', upd); upd();
    byo.querySelector('[data-byo-go]').addEventListener('click', function () {
      var it = items(); if (!it.length) return;
      window.location.href = R + 'cart/' + it.map(function (x) { return x[0] + ':' + x[2]; }).join(',');
    });
  }

  // yorum seridi (2026-09-25): kendiliginden kayar, elle de kaydirilir (parmak, fareyle surukleme, tekerlek). Kartlar 3 kopya,
  // scrollLeft orta kopyada tutulur, iki yone de sonsuz. Dokununca/sureklerken durur, 3 sn sonra devam eder; uzerinde fare varken durur.
  [].forEach.call(d.querySelectorAll('[data-rvw]'), function (rw) {
    var rt = rw.querySelector('.rvw__track'); if (!rt) return;
    var third = function () { return rt.scrollWidth / 3; }, hover = false, holdUntil = 0, acc = 0, drag = null;
    var wrap = function () { var t = third(); if (!t) return; if (rw.scrollLeft < t * 0.5) rw.scrollLeft += t; else if (rw.scrollLeft >= t * 1.5) rw.scrollLeft -= t; };
    var hold = function (ms) { holdUntil = Date.now() + (ms || 3000); };
    var auto = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lastT = Date.now();
    var step = function () {
      var now = Date.now(), dt = Math.min(100, now - lastT); lastT = now;   // hiz sureye bagli (36 px/sn), kare hizindan bagimsiz
      if (auto && !hover && !drag && now > holdUntil && !d.hidden) { acc += 36 * dt / 1000; var n = Math.floor(acc); if (n) { rw.scrollLeft += n; acc -= n; } }
      wrap();
    };
    var init = function () { if (third()) rw.scrollLeft = third(); };
    init(); if (d.readyState !== 'complete') window.addEventListener('load', init, { once: true });
    rw.addEventListener('mouseenter', function () { hover = true; }); rw.addEventListener('mouseleave', function () { hover = false; });
    rw.addEventListener('touchstart', function () { hold(); }, { passive: true }); rw.addEventListener('touchend', function () { hold(); }, { passive: true });
    rw.addEventListener('wheel', function () { hold(); }, { passive: true });
    rw.addEventListener('pointerdown', function (ev) { if (ev.pointerType !== 'mouse') return; drag = { x: ev.clientX, sl: rw.scrollLeft, moved: false }; rw.classList.add('is-drag'); });
    window.addEventListener('pointermove', function (ev) { if (!drag) return; var dx = ev.clientX - drag.x; if (Math.abs(dx) > 3) drag.moved = true; rw.scrollLeft = drag.sl - dx; });
    var endDrag = function () { if (!drag) return; drag = null; rw.classList.remove('is-drag'); hold(); };
    window.addEventListener('pointerup', endDrag); window.addEventListener('pointercancel', endDrag);
    rw.addEventListener('click', function (ev) { if (drag === null && ev.detail && rw.classList.contains('is-drag')) ev.preventDefault(); }, true);
    rw.addEventListener('scroll', wrap, { passive: true });
    setInterval(step, 16);
  });

  // sabit satin alma cubugu: formdaki buton ekrandan cikinca gorunur, tiklayinca ayni formu gonderir
  var sbar = d.querySelector('[data-sbar]'), form = d.querySelector('.bx-form');
  if (sbar && form && 'IntersectionObserver' in window) {
    var fbtn = form.querySelector('button[type=submit]');
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { var on = !x.isIntersecting && x.boundingClientRect.top < 0; sbar.classList.toggle('is-on', on); d.body.classList.toggle('sbar-on', on); });
    }).observe(fbtn);
    sbar.querySelector('[data-sbar-buy]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  // sepete ekle (2026-09-23): ayni form, return_to /cart olur; sepet sayfasinda adet dugmeleri formu gonderir
  var addc = d.querySelector('[data-addcart]'), ret = d.getElementById('bx-return');
  if (addc && ret) addc.addEventListener('click', function () {
    var f = addc.closest('form'); ret.value = R + 'cart'; if (f.requestSubmit) f.requestSubmit(); else f.submit();
  });
  // bone sayfasi (2026-10-18): secilen paket, sepetteki diger bonelerle birlikte en ucuz pakete toplanir (3 siyah sepette,
  // 1 navy eklenince tek 4'lu karisik paket). Kit formu ve diger urunler normal gonderilir.
  if (capPack) d.querySelectorAll('form.bx-form').forEach(function (f) {
    if (f.hasAttribute('data-kit-form')) return;
    f.addEventListener('submit', function (ev) {
      var idEl = f.querySelector('[name=id]'), id = idEl ? +idEl.value : 0;
      if (f.dataset.bxNative || !capPack.info(id)) return;
      ev.preventDefault();
      var q = Math.min(20, Math.max(1, parseInt((f.querySelector('[name=quantity]') || {}).value, 10) || 1));
      var to = (f.querySelector('[name=return_to]') || {}).value || (R + 'checkout');
      capPack.apply(capPack.add({}, id, q)).then(function () { window.location.href = to; })
        .catch(function () { f.dataset.bxNative = '1'; f.submit(); });
    });
  });
  var cartf = d.querySelector('[data-cart]');
  // sepet sayfasi (2026-10-18): farkli zamanda eklenen boneler acilista en ucuz pakete toplanir, sonra sayfa yenilenir
  // (ayni duzeltme 30 sn icinde ikiden fazla denenmez: dongu korumasi)
  if (cartf && capPack && cartf.getAttribute('action')) {
    var rpN = 0; try { var rp = JSON.parse(sessionStorage.getItem('bx-rp') || '{}'); rpN = (Date.now() - (rp.t || 0) < 30000) ? (rp.n || 0) : 0; } catch (x) {}
    if (rpN < 2) capPack.apply().then(function (ch) {
      if (!ch) return;
      try { sessionStorage.setItem('bx-rp', JSON.stringify({ t: Date.now(), n: rpN + 1 })); } catch (x) {}
      window.location.reload();
    }).catch(function () {});
  }
  if (cartf) {
    cartf.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = b.parentNode.querySelector('input'); inp.value = Math.max(0, (+inp.value || 0) + (+b.dataset.q));
        if (cartf.getAttribute('action')) { if (cartf.requestSubmit) cartf.requestSubmit(); else cartf.submit(); }
      });
    });
    cartf.querySelectorAll('input[name="updates[]"]').forEach(function (i) { i.addEventListener('change', function () { if (cartf.getAttribute('action')) cartf.requestSubmit ? cartf.requestSubmit() : cartf.submit(); }); });
  }

  // duyuru cubugu (2026-09-25): 3 mesaj sirayla yukari kayar, fare ustundeyken durur, oklarla elle gecilir
  var ab = d.querySelector('[data-abar]');
  if (ab) {
    var abi = Array.prototype.slice.call(ab.querySelectorAll('li')), abc = 0, abt = null;
    var abrm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var abgo = function (dir) {
      var prev = abi[abc]; abc = (abc + abi.length + dir) % abi.length;
      prev.classList.remove('is-on'); prev.classList.add('is-out'); setTimeout(function () { prev.classList.remove('is-out'); }, 520);
      abi[abc].classList.add('is-on');
    };
    var abstart = function () { if (abi.length > 1 && !abt) abt = setInterval(function () { abgo(1); }, abrm ? 7000 : 4200); };
    var abstop = function () { clearInterval(abt); abt = null; };
    ab.addEventListener('mouseenter', abstop); ab.addEventListener('mouseleave', abstart);
    ab.querySelectorAll('[data-ab]').forEach(function (b) { b.addEventListener('click', function () { abstop(); abgo(+b.dataset.ab); abstart(); }); });
    abstart();
  }

  // dil secici (2026-10-18, patron: Pamira'daki gibi bayrakli): acilir liste; secim cereze yazilir (bx_lang, layout'taki bxLang)
  d.querySelectorAll('[data-lang]').forEach(function (w) {
    var b = w.querySelector('[data-lang-btn]'), m = w.querySelector('[data-lang-menu]');
    if (!b || !m) return;
    var open = function (on) { m.hidden = !on; w.classList.toggle('is-open', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    b.addEventListener('click', function (ev) { ev.stopPropagation(); open(m.hidden); });
    d.addEventListener('click', function (ev) { if (!w.contains(ev.target)) open(false); });
    d.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') open(false); });
  });
  d.querySelectorAll('[data-lang-to]').forEach(function (a) {      // dropdown ve mobil bayrak sirasi
    a.addEventListener('click', function (ev) {
      if (!window.bxLang) return;
      ev.preventDefault(); window.bxLang.pick(a.getAttribute('data-lang-to'));
    });
  });

  // mobil menu (2026-09-23): uc cizgi, ayni nav header'in altina acilir; linke tiklayinca ve Esc ile kapanir
  var hdr = d.querySelector('.hdr'), burger = d.querySelector('[data-menu]');
  // header sigmazsa uc cizgili menuye gec (2026-10-18: uzun dil etiketleri, dar masaustu); olcu her yeniden boyutta
  var hin = d.querySelector('.hdr__in');
  if (hdr && hin) {
    var fit = function () { hdr.classList.remove('is-compact'); if (hin.scrollWidth > hin.clientWidth + 1) hdr.classList.add('is-compact'); };
    fit(); window.addEventListener('resize', fit);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(fit);
  }
  if (hdr && burger) {
    var setMenu = function (on) { hdr.classList.toggle('is-open', on); burger.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    burger.addEventListener('click', function () { setMenu(!hdr.classList.contains('is-open')); });
    hdr.querySelectorAll('.nav a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    d.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') setMenu(false); });
    d.addEventListener('click', function (ev) { if (hdr.classList.contains('is-open') && !hdr.contains(ev.target)) setMenu(false); });
  }

  // politika metni (2026-10-12): Shopify editorunun bos paragraflari (<p><br></p>) bosluk birakmasin; yalniz gercekten bos olanlar
  d.querySelectorAll('.polp .rte p').forEach(function (p) { if (!p.textContent.trim() && !p.querySelector('img,iframe,table')) p.remove(); });

  // para birimi secici (2026-10-12): secince localization formu gonderilir, Shopify ulkeyi cereze yazar ve ayni sayfaya doner
  d.querySelectorAll('[data-loc]').forEach(function (s) {
    s.addEventListener('change', function () { if (s.form && s.form.getAttribute('action') !== '#') s.form.submit(); });
  });

  // en uste don (2026-09-23): 600px asagi inince gorunur, WhatsApp butonunun ustunde durur
  var tt = d.querySelector('[data-totop]');
  if (tt) {
    var ttUpd = function () { tt.classList.toggle('is-on', window.scrollY > 600); };
    window.addEventListener('scroll', ttUpd, { passive: true }); ttUpd();
    tt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // urun seridi oklari
  var st = d.querySelector('[data-shop-track]');
  d.querySelectorAll('[data-shop]').forEach(function (b) {
    b.addEventListener('click', function () { if (st) st.scrollBy({ left: +b.dataset.shop * st.clientWidth * 0.8, behavior: 'smooth' }); });
  });

  // reveal
  var els = d.querySelectorAll('.rv');
  if (!('IntersectionObserver' in window)) { els.forEach(function (x) { x.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (x) { io.observe(x); });
})();
